const HOSTED_USAGE_URL = 'https://unlock.payhook.link/usage/'
export const FEATURE_USAGE_KEY = 'pro'

function normalizeLimit (value) {
  if (value == null || value === '') return null
  const parsed = Number(value)
  return Number.isInteger(parsed) && parsed >= 1 && parsed <= 1000000
    ? parsed
    : null
}

function pickStoredLimits (featureUsage) {
  const source = featureUsage?.features && typeof featureUsage.features === 'object'
    ? featureUsage.features
    : {}
  const preferred = source[FEATURE_USAGE_KEY]
  if (preferred && typeof preferred === 'object') {
    return {
      weekly: normalizeLimit(preferred.weekly),
      monthly: normalizeLimit(preferred.monthly)
    }
  }

  for (const limits of Object.values(source)) {
    if (!limits || typeof limits !== 'object') continue
    const weekly = normalizeLimit(limits.weekly)
    const monthly = normalizeLimit(limits.monthly)
    if (weekly != null || monthly != null) return { weekly, monthly }
  }

  return { weekly: null, monthly: null }
}

export function normalizeDashboardFeatureUsage (featureUsage) {
  const { weekly, monthly } = pickStoredLimits(featureUsage)
  const hasCaps = weekly != null || monthly != null
  return {
    enabled: featureUsage?.enabled !== false && hasCaps,
    weekly,
    monthly
  }
}

export function serializeDashboardFeatureUsage ({ enabled, weekly, monthly } = {}) {
  const normalizedWeekly = normalizeLimit(weekly)
  const normalizedMonthly = normalizeLimit(monthly)
  const hasCaps = normalizedWeekly != null || normalizedMonthly != null

  if (enabled && !hasCaps) {
    throw new Error('Set a weekly or monthly cap before enabling usage-based fallback.')
  }

  if (!hasCaps) {
    return { enabled: false, features: {} }
  }

  return {
    enabled: Boolean(enabled),
    features: {
      [FEATURE_USAGE_KEY]: {
        weekly: normalizedWeekly,
        monthly: normalizedMonthly
      }
    }
  }
}

export function buildHostedUsagePreviewUrl ({
  paymentHookId,
  testMode = false,
  feature = FEATURE_USAGE_KEY,
  weeklyLimit,
  monthlyLimit,
  unit = 'minute'
} = {}) {
  const url = new URL(HOSTED_USAGE_URL)
  if (paymentHookId) url.searchParams.set('paymentHookId', paymentHookId)
  if (testMode) url.searchParams.set('testMode', 'true')
  if (feature) url.searchParams.set('feature', feature)
  if (unit) url.searchParams.set('unit', unit)

  const periods = [
    ['weekly', normalizeLimit(weeklyLimit), 0.42],
    ['monthly', normalizeLimit(monthlyLimit), 0.57]
  ]
  for (const [period, limit, ratio] of periods) {
    if (limit == null) continue
    url.searchParams.set(`${period}Used`, String(Math.min(limit, Math.round(limit * ratio))))
    url.searchParams.set(`${period}Limit`, String(limit))
  }
  return url.toString()
}
